import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const formWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.submit-form-widget-btn', this, this.send);
            $(document).on('change', '.form-person-type', this, this.selectPersonType);
        },
		selectPersonType(event) {
			const _this = event.data;
			event.preventDefault();

            if ($(this).is(':checked')) {
                $('.form-company-wrapper').show();
            } else {
                $('.form-company-wrapper').hide();
            }
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let mid = $(this).data('mid');

			if (_this.isLoading) {
                return false;
            }

			$('.form-msgs-holder').hide();
            $('.form-widget').find('.form-control').removeClass('is-invalid');
            $('.form-widget').find('.form-check-input').removeClass('is-invalid');

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

            var appartmentTypes = $('input[name="form_appartment_type[]"]:checked').map(function() {
                return this.value;
            }).get().join(',');

			var values='';
            values+='module_id=' + mid;
            values+='&person_type=' + ($('#form_person_type_' + mid).is(":checked")?1:0);
            values+='&name=' + $('#form_name_' + mid).val();
            values+='&email=' + $('#form_email_' + mid).val();
            values+='&phone=' + $('#form_phone_' + mid).val();
            values+='&company=' + $('#form_company_' + mid).val();
            values+='&company_cui=' + $('#form_company_cui_' + mid).val();
            values+='&appartment_types=' + appartmentTypes;
            values+='&purchase_intention=' + $('#form_purchase_intention_' + mid + ' option:selected').val();
            values+='&buget=' + $('#form_buget_' + mid + ' option:selected').val();
            values+='&message=' + $('#form_message_' + mid).val();
            values+='&newsletter=' + ($('#form_newsletter_' + mid).is(":checked")?1:0);
            values+='&privacy=' + ($('#form_privacy_' + mid).is(":checked")?1:'');
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
			$.ajax({
                type: "POST",
                url: baseURL + '/form/send',
                data: values,
                success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#form_' + errorKey + '_' + mid).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                            //$("#"+errorKey).closest('.form-group').addClass('has-error');
                            //$("#"+errorKey).css('border', '1px solid red');
                        }
                        //errorHtml
                        errorHtml;
                        $('#form-error-msg').html(errorHtml);
                        $('#form-error-msg').fadeIn();
                        $('#form-error-msg').delay(10000).fadeOut();
                        //errors
                        return false;
                    }

					if (response.status == 1) {
						$('.form-widget').find('.form-control').val('');
						$('.form-widget').find('.form-check-input').prop('checked', false);

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': ''});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						window.lintrk('track', { conversion_id: 9865345 });

						return false;
					}

					if (response.status == 2) {
						$('#form-error-msg').html(response.errors);
                        $('#form-error-msg').fadeIn();
                        $('#form-error-msg').delay(10000).fadeOut();
                    }

					if (response.status == 3) {
						$('#form-error-msg').html(response.errors);
                        $('#form-error-msg').fadeIn();
                        $('#form-error-msg').delay(10000).fadeOut();
                    }
                },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
            });
		}
    };

    if ($('.form-widget').length) {
        formWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/form.js